/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-09 15:06:36
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-03 13:21:49
 * @FilePath: /unifyxp-v2-store-portal/src/components/ColorPicker/ColorPicker.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import { CaretDownOutlined } from '@ant-design/icons';
import React from 'react';
import { ColorResult, SketchPicker } from 'react-color';
import { Button, PopOver } from 'src/components/Antd';
import Options from './ColorOptions/ColorOptions';
import css from './css.less';
import classNames from 'classnames';

interface IProps {
  onChange(hex: string): void;
  color: string;
  tabIndex?: number;
  multi?: boolean;
  options?: any;
  disableAlpha?: boolean;
  disable?: boolean;
  id?: string;
  defaultValue?: string;
}

const ColorPicker = (props: IProps) => {
  const {
    disable,
    multi,
    onChange,
    color,
    options,
    disableAlpha,
    id,
    defaultValue,
  } = props;

  return (
    <div className={css.wrapper}>
      <PopOver
        id={id}
        {...(disable && { visible: false })}
        placement='bottomRight'
        overlayClassName={css.popoverClassName}
        overlay={
          <div
            {...(!multi && { style: { top: 46 } })}
            className={css.colorPickerContainer}>
            {multi ? (
              <SketchPicker
                width={250}
                disableAlpha={disableAlpha}
                color={color || defaultValue || 'rgba(255,255,255,1)'}
                onChange={(color: ColorResult) => {
                  const alpha = color.rgb.a;
                  let rgbaColor = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
                  if (alpha === 1) {
                    rgbaColor = color.hex;
                  }
                  onChange(rgbaColor);
                }}
                presetColors={[
                  {
                    color: 'rgba(0,0,0,1)',
                    title: 'Black',
                  },
                  {
                    color: 'rgba(255,255,255,1)',
                    title: 'Plain White',
                  },
                ]}
              />
            ) : (
              <Options
                options={options || ['rgba(0,0,0,1)', 'rgba(255,255,255,1)']}
                onClick={onChange}
              />
            )}
          </div>
        }
        trigger='click'>
        <div className={`${css.btn} ${disable ? css.disabled : ''}`}>
          <div
            className={css.colorDisplay}
            style={{ background: color || defaultValue || 'rgba(0,0,0,1)' }}
          />
          <Button
            disabled={disable}
            style={{
              backgroundColor: disable ? '#F3F3F3' : undefined,
              borderColor: disable ? '#B9BCBF' : undefined,
            }}
            className={classNames(css.triggerContainer)}>
            <CaretDownOutlined
              rev
              style={{ color: disable ? '#DCDCDC' : undefined }}
              className={classNames(css.icon)}
            />
          </Button>
        </div>
      </PopOver>
      {/* <div className={css.colorText}>{color}</div> */}
    </div>
  );
};

export default ColorPicker;
